import axios from "axios";

export const prcoessQuery = async (reqBody: any, abortSignal: AbortSignal) => {
  try {
    const auth = axios.defaults.headers.common["Authorization"];
    const response = await fetch(`${process.env.REACT_APP_DOMAIN}v1/outlookbot/api/completion`, {
      method: "POST",
      headers: {
        Accept: "text/event-stream",
        "Content-Type": "application/json",
        Authorization: `${auth}`,
      },
      signal: abortSignal,
      body: JSON.stringify(reqBody),
    });
    // alert(response);
    return response;
  } catch (error) {
    console.error(error);
    // alert(error);
    return null;
  }
};

export const getModels = async () => {
  try {
    console.log(process.env.REACT_APP_DOMAIN);
    const response = await axios.get(
      `${process.env.REACT_APP_DOMAIN}v1/outlookbot/settings/models`
    );
    return response?.data?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getAllLanguages = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DOMAIN}v1/outlookbot/settings/languages`
    );
    return response?.data?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getDivisionsWithBrand = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DOMAIN}v1/outlookbot/settings/division-brands`
    );
    return response?.data;
  } catch (error) {
    console.error(error);
  }
};

export const getBrandDetails = async (brandId: string) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DOMAIN}v1/outlookbot/settings/brands/${brandId}`
    );
    return response?.data;
  } catch (error: any) {
    console.error(error);
  }
};

export const getDefaultValues = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_DOMAIN}v1/outlookbot/settings/user/default`
    );
    return response?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const setDefaultValues = async (model, language, tovId, personaId) => {
  try {
    const data = {
      name_of_model: model,
      response_language: language,
      tov_id: tovId,
      persona_id: personaId,
    };
    const response = await axios.put(
      `${process.env.REACT_APP_DOMAIN}v1/outlookbot/settings/user/default`,

      data
    );
    return response?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
